import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { AccommodationModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class AccommodationClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'accommodation');
  }

  public async getAllAsync(): Promise<BaseDataResponse<AccommodationModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<AccommodationModel[]>>('', '');
  }

  public async createAsync(model: AccommodationModel): Promise<BaseDataResponse<AccommodationModel>> {
    return await this.postHttpAsync<BaseDataResponse<AccommodationModel>, AccommodationModel>('', model);
  }

  public async updateAsync(model: AccommodationModel): Promise<BaseDataResponse<AccommodationModel>> {
    return await this.putHttpAsync<BaseDataResponse<AccommodationModel>, AccommodationModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }
}
